import { Restriction } from '../store/types';

export const getLabelForRestriction = (restriction: Restriction, shortcut?: boolean) =>
  `features.restriction.${restriction}${shortcut ? '.shortcut' : ''}`;
